import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const InputWrapper = styled.div`
  width: 100%;
  .label {
    p {
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      color: ${theme.colours.blackText};
      display: inline-block;
      margin-bottom: 4px !important ;
      padding-inline-start: 12px;
      line-height: 22px;
      span {
        color: ${theme.colours.error} !important;
        font-size: 15px !important;
      }
    }
    &.questionForm {
      p {
        font-family: ${theme.fonts.Regular};
        font-weight: 400;
        color: ${theme.colours.blackText};
      }
    }
  }
  input {
    width: 100%;
    font-family: ${theme.fonts.Regular};
    font-size: 13px;
    line-height: 22px;
    color: ${theme.colours.black};
    background-color: ${theme.colours.white};
    padding: 0 12px;
    height: 32px;
    border: 1px solid rgb(200, 200, 200);
    border-radius: 6px !important;

    @media (max-width: 768px) {
      border-top: '0.75px solid #d4d4d4 !important';
    }
    outline: none;
    &:lang(ar) {
      text-align: right;
    }
    &::placeholder {
      color: ${theme.colours.Nickel} !important;
    }
    &:-webkit-autofill,
    :-webkit-autofill:focus {
      transition: background-color 0s 600000s, color 0s 600000s;
    }
    &:disabled {
      background-color: ${theme.colours.lightGray2};
      border: 0.5px solid ${theme.colours.newOutline};
      color: ${theme.colours.SpanishGray};
      opacity: 0.6;
      cursor: not-allowed;
    }
    &:read-only {
      background-color: ${theme.colours.lightGray3};
      border: 0.5px solid ${theme.colours.newOutline};
      color: #969696;
      opacity: 0.6;
      cursor: not-allowed;
    }
    &:focus {
      font-size: 13px;
    }
  }
  input.hasError {
    border: 0.5px solid ${theme.colours.error} !important;
  }
  input.logInput {
    border: none !important;
  }
  div.icon {
    top: calc(50%);
    height: 90%;
    margin: auto 0;
    display: flex;
    align-items: center;
    position: absolute;
    /* border: 1px solid rgb(200, 200, 200); */
    border-right: 0;
    font-size: 14px;
    color: ${theme.colours.blackText};
    transform: translateY(-50%);
    background-color: ${theme.colours.lightGray3};
    padding: 0px 25.5px;
    margin-left: 1px;
    &:lang(ar) {
      right: auto;
      left: 0.25px;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    &:lang(en) {
      right: 0.25px;
      left: auto;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
    &.no_label {
      top: calc(50%);
    }
  }

  input.hasError + div.icon {
    border: none !important;
    border-right: 0 !important ;
    margin-left: 2px;
  }

  & > p {
    color: ${theme.colours.error};
    margin-top: 8px;
    font-size: 13px;
    font-family: ${theme.fonts.Medium};
  }
`;

export const OtpInputContainer = styled.div<{ small?: boolean }>`
  font-family: ${theme.fonts.Medium};
  font-size: ${({ small }) => (small ? '12px' : '18px')};
  background-color: ${theme.colours.Lotion};
  padding: 0px 20px;
  border: 1px solid rgb(200, 200, 200);
  border-radius: 8px;
  outline: none;
  display: flex;
  margin-bottom: ${theme.space_size};
  direction: ltr;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  .otp-input {
    flex: 1;
    color: ${theme.colours.blackText};
    font-weight: 600;
    padding: 12px 20px;
    text-align: center;
    border: none;
    width: 33.3%;
    height: ${({ small }) => (small ? '32px' : 'auto')};
    margin-right: 8px; /* Adjust the spacing between OTP inputs */
    background-color: ${theme.colours.Lotion};
    &:focus {
      outline: none;
    }
  }
`;
